import { Box, Button, Typography } from "@mui/material";

/**
 * Shown when auth check is complete and access is denied.
 *
 * variant="not-logged-in"  – no session at all; shows "Login" button
 * variant="unauthorized"   – session exists but role is insufficient
 */
const AuthGate = ({ variant = "unauthorized" }) => {
	const notLoggedIn = variant === "not-logged-in";

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			height="100vh"
			flexDirection="column"
			gap={2}
		>
			{notLoggedIn ? (
				<>
					<Typography variant="h3">Not Logged In</Typography>
					<Typography variant="body1" color="text.secondary">
						You must be logged in to view this page.
					</Typography>
					<Button
						variant="contained"
						onClick={() => (window.location.href = "/login")}
					>
						Login
					</Button>
				</>
			) : (
				<>
					<Typography variant="h3">Unauthorized</Typography>
					<Typography variant="body1" color="text.secondary">
						You don't have permission to access this page.
					</Typography>
					<Button
						variant="outlined"
						onClick={() => (window.location.href = "/")}
					>
						Go Home
					</Button>
				</>
			)}
		</Box>
	);
};

export default AuthGate;
